import {PrizeType} from 'utils/DBUtils';
import Columns from './columns';

export default {
  editorial: {
    columns: [
      Columns.Winner,
      Columns.Prize,
      Columns.Status,
      Columns.Notified,
      Columns.Renotified,
      Columns.Ordered,
      Columns.Notes,
      Columns.Forfeited,
      Columns.PrizeLink,
      Columns.EditStory,
      Columns.FeaturedToggle,
    ],

    prizeType: PrizeType.RAFFLE,
    defaultSort: 'dateContacted',

    documentTitle: 'Sweeps Winners',
    topLevelClassName: 'sweeps-winners',
    spinnerMessage: 'loading.winners.editorial',
    dateFormat: 'MM/DD/YY'
  },

  sponsored: {
    columns: [
      Columns.Winner,
      Columns.Prize,
      Columns.Status,
      Columns.Notified,
      Columns.Claimed,
      Columns.Ordered,
      Columns.Notes,
      Columns.Forfeited,
      Columns.PrizeLink,
      Columns.EditStory,
      Columns.FeaturedToggle,
      Columns.BreakId
    ],

    prizeType: PrizeType.CHALLENGE,
    defaultSort: '_created', // entry date

    documentTitle: 'Sponsored Winners',
    topLevelClassName: 'sponsored-winners',
    spinnerMessage: 'loading.winners.sponsored',
    dateFormat: 'MM/DD/YY'
  }
};



// WEBPACK FOOTER //
// ./public/pages/ListWinners/configs.js